import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-status-badge-active.svg";
import { ReactComponent as InactiveImg } from "../../../img/ico-status-badge-idle.svg";
import { ReactComponent as RestoringImg } from "../../../img/ico-status-badge-commit.svg";
import { ReactComponent as LockedImg } from "../../../img/ico-status-badge-lock.svg";
import { ReactComponent as MigrationImg } from "../../../img/ico-status-badge-migration.svg";
import { ReactComponent as PoweringUpImg } from "../../../img/ico-status-badge-on.svg";
import { ReactComponent as PoweringDownImg } from "../../../img/ico-status-badge-off.svg";
import { ReactComponent as PausedImg } from "../../../img/ico-status-badge-pause.svg";
import { ReactComponent as SuspendImg } from "../../../img/ico-status-badge-stop.svg";
import { ReactComponent as RebootImg } from "../../../img/ico-status-badge-restart.svg";
import { ReactComponent as WaitForLaunchImg } from "../../../img/ico-status-badge-ready.svg";
import { ReactComponent as SavingImg } from "../../../img/ico-status-badge-sleep.svg";
import { ReactComponent as NotRespondingImg } from "../../../img/ico-status-badge-no-response.svg";
import { ReactComponent as UnknwonImg } from "../../../img/ico-status-badge-unknown.svg";

import InstanceTypeAdd from "./InstanceTypeAdd";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import InstanceTypeUpdate from "./InstanceTypeUpdate";

export interface InstanceTypeData {
    vm_type_id: string,
    vm_type_name: string,
    vm_type_description: string,
    share_type_code: string,
    host_cluster_type_code: string,
    vcpu_count: number,
    memory_capacity_mb: number,
    root_disk_capacity_gb: number,
    ephemeral_disk_capacity_gb: number,
    swap_disk_capacity_mb: number,
    rx_tx_factor: number,
    gpu_available_yn: boolean,
    create_ts: string,
    update_ts: string,
    project: {
        project_id: string,
        project_name: string
    }
}

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("INSTANCE_TYPE_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "INSTANCE_TYPE_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "INSTANCE_TYPE_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "INSTANCE_TYPE_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("INSTANCE_TYPE_NAME_TEXT"),
        accessor: "vm_type_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("INSTANCE_CPU_TEXT"),
        accessor: "vcpu_count",
        disableSortBy: false,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.resourceContainer}}>
                {value} Core
            </div>
        )
    },
    {
        Header: i18n.t("INSTANCE_MEMORY_TEXT"),
        accessor: "memory_capacity_mb",
        disableSortBy: false,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.resourceContainer}}>
                {value} MB
            </div>
        )
    },
    {
        Header: i18n.t("INSTANCE_ROOT_DISK_TEXT"),
        accessor: "root_disk_capacity_gb",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.resourceContainer}}>
                {value} GB
            </div>
        )
    },
    {
        Header: i18n.t("INSTANCE_SWAP_DISK_TEXT"),
        accessor: "swap_disk_capacity_mb",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.resourceContainer}}>
                {value} MB
            </div>
        )
    },
    {
        Header: i18n.t("INSTANCE_SHARE_TYPE_TEXT"),
        accessor: "share_type_code",
        disableSortBy: false,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 50, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 10,
                backgroundColor: value === "PUB" ? "#66abe8" : value === "PRJ" ? "#92ca6e" : "#b6bfce",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#fff"
            }}>
                {
                    value === "PUB" ? "Public"
                    : value === "PRJ" ? "Personal"
                    : value === "HDN" ? "Hidden"
                    : "None"
                }
            </div>
        )
    },
    {
        Header: i18n.t("INSTANCE_TYPE_GPU_INCLUDE_TEXT"),
        accessor: "gpu_available_yn",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value === true ? <StatusStableImg /> : <StatusBlockImg />}
            </div>
        )
    },
    {
        Header: i18n.t("INSTANCE_TARGET_HOST_CLUSTER_TEXT"),
        accessor: "host_cluster_type_code",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div>
                {
                value === "CMP" ?
                    <div style={{...className.statusContainer, color: "#5b9782", backgroundColor: "#ddf2e8"}}>
                    <>{i18n.t("COMPUTE_TYPE_TEXT")}</>
                    </div>
                : value === "MEM" ?
                    <div style={{...className.statusContainer, color: "#ae4f5a", backgroundColor: "#faedf0"}}>
                    <>{i18n.t("MEMORY_TYPE_TEXT")}</>
                    </div>
                : value === "GPU" ?
                    <div style={{...className.statusContainer, color: "#806dc6", backgroundColor: "#eeecfc"}}>
                    <>{i18n.t("GPU_TYPE_TEXT")}</>
                    </div>
                : value === "STRG" ?
                    <div style={{...className.statusContainer, color: "#806dc6", backgroundColor: "#eeecfc"}}>
                    <>{i18n.t("STORAGE_TYPE_TEXT")}</>
                    </div>
                : value === "NET" ?
                    <div style={{...className.statusContainer, color: "#806dc6", backgroundColor: "#eeecfc"}}>
                    <>{i18n.t("NIC_TYPE_TEXT")}</>
                    </div>
                :
                    <div style={{...className.statusContainer, color: "#9ca3ad", backgroundColor: "#e6ebf2"}}>
                    <>{i18n.t("NORMAL_TYPE_TEXT")}</>
                    </div>
                }
            </div>
        )
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.dateContainer}}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
];
export interface VmImageTableFields {
    vmId: string;
    vmName: string;
    vmDescription: string;
    vmStatusCode : string;
    vmUsageTypeCode: string;
    username: string;
    userGroupName: string;
    createDate: string;
    clusterId: string;
}

export const instanceTypeAddModalContent = {
    title: i18n.t("INSTANCE_TYPE_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <InstanceTypeAdd />,
}

export const instanceTypeUpdateModalContent = {
    title: i18n.t("INSTANCE_TYPE_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            deleteButtonYn: false,
            cancelButtonYn: false,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <InstanceTypeUpdate />,
}


const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 1,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    }
}